import { Button } from "@monekineko/ui-kit";
import { useState } from "react";
import { FriendsScreen } from "./screens/FriendsScreen.js";
import { LeaderboardScreen } from "./screens/LeaderboardScreen.js";
import { LevelScreen } from "./screens/LevelScreen.js";
import { MapScreen } from "./screens/MapScreen.js";
import styles from "./screens/screens.module.css";
import { useSession } from "./state/session.js";

// Переходов между экранами мало, и все они внутри одного мини-приложения,
// поэтому роутер не нужен: хватает состояния.

type Screen = { name: "map" } | { name: "level"; levelId: string } | { name: "friends" } | { name: "board" };

export function App() {
  const [screen, setScreen] = useState<Screen>({ name: "map" });
  const { error, loading } = useSession();

  if (error && !loading) {
    return (
      <div className={styles.center}>
        <p className={styles.errorText}>{error}</p>
        <Button onClick={() => window.location.reload()}>Попробовать снова</Button>
      </div>
    );
  }

  if (screen.name === "level") {
    return <LevelScreen levelId={screen.levelId} onExit={() => setScreen({ name: "map" })} />;
  }

  if (screen.name === "friends") {
    return <FriendsScreen onBack={() => setScreen({ name: "map" })} />;
  }

  if (screen.name === "board") {
    return <LeaderboardScreen onBack={() => setScreen({ name: "map" })} />;
  }

  return (
    <MapScreen
      onPlay={(levelId) => setScreen({ name: "level", levelId })}
      onOpenFriends={() => setScreen({ name: "friends" })}
      onOpenLeaderboard={() => setScreen({ name: "board" })}
    />
  );
}
